import { Box, Text } from "@chakra-ui/react";

import Colors from "../Utils/Colors";
import {
  GeneralDimensions,
  MobileDimensions,
  TabletDimensions,
  WebDimensions
} from "../Utils/Dimensions";
import { Strings } from "../Utils/Strings";
import Font, { Spacing } from "../Utils/Calligraphy";

const HelloBox = () => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Box
        display={"flex"}
        width={GeneralDimensions.FullWidth}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
        padding={Spacing.Padded}
        borderRadius={"0rem"}
        bgColor={Colors.Background}
      >
        <Text
          fontFamily={Font.Medium}
          fontSize={{
            base: MobileDimensions.TitleFontSize,
            md: TabletDimensions.TitleFontSize,
            lg: WebDimensions.TitleFontSize
          }}
          color={Colors.Text}
          textAlign={Spacing.TextAlignCenter}
        >
          {Strings.HomeTitle}
        </Text>
        <Text
          fontFamily={Font.Regular}
          fontSize={{
            base: MobileDimensions.SubtitleFontSize,
            md: TabletDimensions.SubtitleFontSize,
            lg: WebDimensions.SubtitleFontSize
          }}
          color={Colors.Text}
          textAlign={Spacing.TextAlignCenter}
        >
          {Strings.HomeHeadline}
        </Text>
      </Box>
    </Box>
  );
};

export default HelloBox;
